var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"app-video-body",attrs:{"title":"bili","src":_vm.videoSrc,"allowfullscreen":true,"sandbox":"allow-top-navigation allow-same-origin allow-forms allow-scripts"}})}
var staticRenderFns = []

export { render, staticRenderFns }